module.exports = __webpack_public_path__ + "static/GlitchlessSonyax56-93d5f1c8b4755e11296745695a5748fb.png";